export const SIGNIN_USER = "SIGNIN_USER";
export const REGISTER_USER = "REGISTER_USER";
export const EDIT_USER ="EDIT_USER";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const DELETE_USER = "DELETE_USER";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
